<template>
  <div class="new-dynamic tw-w-full tw-bg-white tw-py-16">
    <div class="home-section-inner">
        <div class="tw-flex tw-items-center tw-justify-between tw-mb-8">
          <h2 class="section-title">
            {{ $t("最新活动") }}
          </h2>
          <div
            class="tw-flex tw-items-center tw-cursor-pointer hover:tw-text-primary tw-transition-colors"
            @click="handleMoreClick"
          >
            <span class="more-text">
              {{ $t("更多活动") }}
            </span>
            <img
              src="@/assets/home/icon_fanhui.png"
              alt=""
              class="tw-w-4 tw-h-4 tw-ml-1"
            />
          </div>
        </div>

        <div class="tw-flex tw-w-full">
          <div
            class="first-card tw-relative"
            style="width: 25%; flex-shrink: 0;"
          >
            <img
              v-if="$screen.lg"
              src="@/assets/home/first.png"
              alt=""
              class="tw-absolute"
              style="
                width: 111.64px;
                height: 104.46px;
                top: 16px;
                right: 38px;
                bottom: 12px;
                z-index: 1;
              "
            />

            <div
              class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-px-4 tw-relative"
              style="
                height: 132px;
                background: linear-gradient(79deg, #fffefe 0%, #fcf1e8 100%);
                border: 1px solid #e9e9e9;
              "
              :style="{
                borderRadius:
                  (isActivityLoading || activityList.length) && $screen.lg
                    ? '12px 0px 0px 12px'
                    : '12px',
              }"
            >
              <img
                src="@/assets/home/run.png"
                alt=""
                class="tw-mb-3"
                style="height: 32px"
              />
              <p
                class="tw-text-sm tw-font-medium tw-text-textMain tw-mb-2 tw-leading-tight"
              >
                {{ $t("凭借12年Web3行业经验居行业领先地位") }}
              </p>
              <p class="tw-text-xs tw-text-textDisabled tw-leading-tight">
                {{ $t("为企业提供稳定、高效的落地支持") }}
              </p>
            </div>
          </div>

          <div
            v-if="isActivityLoading"
            class="activity-card-list"
            style="width: 75%;"
            aria-hidden="true"
          >
            <div
              v-for="index in skeletonCount"
              :key="`activity-skeleton-${index}`"
              class="activity-card activity-card-skeleton"
              :style="{
                width: `${100 / skeletonCount}%`,
                borderRadius:
                  index === skeletonCount && $screen.lg
                    ? '0px 12px 12px 0px'
                    : '0px',
              }"
            >
              <div class="activity-skeleton-cover skeleton-shimmer"></div>
              <div class="activity-info">
                <div class="activity-title-row">
                  <div class="activity-skeleton-title skeleton-shimmer"></div>
                  <div class="activity-skeleton-status skeleton-shimmer"></div>
                </div>
                <div class="activity-skeleton-line skeleton-shimmer"></div>
                <div class="activity-skeleton-line short skeleton-shimmer"></div>
              </div>
            </div>
          </div>

          <div
            v-else-if="activityList.length"
            class="activity-card-list"
            style="width: 75%;"
          >
            <div
              v-for="(item, index) in activityList"
              :key="item.id"
              class="activity-card tw-cursor-pointer"
              :style="{
                width: `${100 / activityList.length}%`,
                borderRadius:
                  index === activityList.length - 1 && $screen.lg
                    ? '0px 12px 12px 0px'
                    : '0px',
              }"
              @click="handleActivityClick(item)"
            >
              <img :src="item.image || skeIcon" alt="" class="activity-cover" />
              <div class="activity-info">
                <div class="activity-title-row">
                  <h3 class="activity-title">{{ item.name }}</h3>
                  <span
                    class="activity-status"
                    :class="{ ended: item.status === 3 }"
                  >
                    {{ $t(getStatusText(item.status)) }}
                  </span>
                </div>
                <p class="activity-meta">{{ getTimeText(item) }}</p>
                <p class="activity-meta">
                  {{ getLocationText(item.location) }}
                </p>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import skeIcon from "@/assets/activityMeet/ske.png";
import { getActivityList } from "@/api/activityMeet/index.js";
import {
  formatActivityTime,
  getActivityStatusText,
  isOnlineLocation,
  normalizeHomeActivities,
} from "./utils/homeActivity";

export default {
  name: "newDynamic",
  data() {
    return {
      activityList: [],
      isActivityLoading: true,
      skeletonCount: 3,
      skeIcon,
    };
  },
  created() {
    this.fetchActivityList();
  },
  methods: {
    async fetchActivityList() {
      try {
        const { code, data } = await getActivityList();
        if (code === 0) {
          this.activityList = normalizeHomeActivities(data);
        }
      } catch (error) {
        console.warn("获取首页活动失败", error);
      }
      this.isActivityLoading = false;
    },
    getStatusText(status) {
      return getActivityStatusText(status);
    },
    getTimeText(activity) {
      const time = formatActivityTime(activity, this.$i18n.locale);
      return time ? `${time.date} ${time.time} UTC+8` : "--";
    },
    getLocationText(location) {
      if (isOnlineLocation(location)) {
        return this.$t("在线会议");
      }
      return location || "--";
    },
    handleActivityClick(item) {
      if (!item || !item.id) return;
      this.$router.push({
        name: "activity-detail",
        params: { id: item.id },
      });
    },
    handleMoreClick() {
      this.$router.push({
        path: "/activity",
      });
    },
  },
};
</script>

<style scoped>
.section-title {
  color: #111111;
  font-size: 16px;
  font-weight: 600;
}

.more-text {
  color: #666666;
  font-size: 14px;
  font-weight: 400;
}

.activity-card-list {
  display: flex;
}

.activity-card {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 132px;
  padding: 16px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.activity-card:hover {
  box-shadow: 0 8px 24px rgb(15 23 42 / 8%);
  transform: translateY(-2px);
}

.activity-card-skeleton {
  pointer-events: none;
}

.activity-card-skeleton:hover {
  box-shadow: none;
  transform: none;
}

.activity-cover {
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 8px;
}

.activity-info {
  min-width: 0;
  flex: 1;
}

.activity-title-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.activity-title {
  flex: 1;
  min-width: 0;
  margin-bottom: 6px;
  overflow: hidden;
  color: #111111;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activity-status {
  flex: 0 0 auto;
  padding: 2px 6px;
  color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  background: #01bd8b;
  border-radius: 4px;
}

.activity-status.ended {
  color: #666666;
  background: #e9e9e9;
}

.activity-meta {
  margin-bottom: 4px;
  overflow: hidden;
  color: #666666;
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activity-skeleton-cover {
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  border-radius: 8px;
}

.activity-skeleton-title {
  flex: 1;
  height: 18px;
  border-radius: 4px;
}

.activity-skeleton-status {
  flex: 0 0 48px;
  height: 22px;
  border-radius: 4px;
}

.activity-skeleton-line {
  width: 78%;
  height: 14px;
  margin-top: 12px;
  border-radius: 4px;
}

.activity-skeleton-line.short {
  width: 48%;
}

.skeleton-shimmer {
  background: linear-gradient(
    90deg,
    #f2f4f8 0%,
    #e7ebf2 45%,
    #f2f4f8 90%
  );
  background-size: 200% 100%;
  animation: activitySkeletonShimmer 1.2s ease-in-out infinite;
}

@keyframes activitySkeletonShimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
